// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root___4ntq","footer":"ModalCreateQualiphyProcedure_footer__1Snxk","additionData":"ModalCreateQualiphyProcedure_additionData__2l8Lh"};